import React from "react";
import { setCurrentView } from 'core/utils';
import { OrderingTaskEditTemplate } from 'themes/application/dashboard/pages';
import { OrderingTaskEditViewStore } from 'application/dashboard/stores';
import { observer } from 'mobx-react';

@setCurrentView((rootStore, componentProps) => new OrderingTaskEditViewStore(rootStore, componentProps), 'orderingTaskEditView')
@observer
class OrderingTaskEdit extends React.Component {
    render() {
        return <OrderingTaskEditTemplate {...this.props} />;
    }
}

export default OrderingTaskEdit;
